import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import Lenis from 'lenis';

// Image Imports
import mobileDentalBus from '../assest/hero/dentalbus101.png';
import teethexplain from '../assest/hero/teethexplain101.png';
import bloodDonation from '../assest/hero/blooddonation101.png';

// Import slick-carousel css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.8,
      smoothWheel: true,
      smoothTouch: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  const slides = [
    {
      badge: "Advanced Technology",
      title: "Digital Diagnosis & Patient Education",
      description:
        "Using cutting-edge digital kiosks and intraoral scanning to help you visualize and understand your dental health.",
      image: teethexplain,
      cta: "Learn More",
    },
    {
      badge: "Community Outreach",
      title: "Taking Care to the Doorstep: Mobile Clinic",
      description:
        "Our 'Child Smiles' initiative brings world-class dental checkups to schools via our fully equipped Mobile Dental Bus.",
      image: mobileDentalBus,
      cta: "Our Initiatives",
    },
    {
      badge: "Social Responsibility",
      title: "Dedicated to Service Beyond Dentistry",
      description:
        "Proudly recognized for our commitment to community health through blood donation camps and social welfare.",
      image: bloodDonation,
      cta: "Join Our Cause",
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true,
    arrows: false,
    pauseOnHover: false,
    dotsClass: "slick-dots custom-dots",
  };

  return (
    <section id="home" className="relative w-full overflow-hidden -mt-6 sm:-mt-12 sm:mb-[-20%] 2xl:mb-[0%]">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <div className="relative h-[500px] sm:h-[540px] md:h-[680px] lg:h-[780px] xl:h-screen 2xl:h-screen overflow-hidden">

{/* Full Width Background Image */}
<div className="absolute inset-0 -top-8 sm:-top-4">
  <img
    src={slide.image}
    alt={slide.title}
    className="w-full h-[110%] sm:h-full object-cover scale-110 sm:scale-100 sm:object-right "
  />

  {/* Dark Overlay */}
  <div className="absolute inset-0 lg:bg-black/10 sm:bg-black/20 2xl:bg-black/20"></div>
</div>

{/* Content */}
<div className="relative z-10 flex items-center h-full px-4 sm:px-6 lg:px-8 pt-0">
  <motion.div
    className="max-w-3xl text-white w-full"
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
                  {/* Badge */}
                  <div
                    className="
                      inline-flex
                      items-center
                      gap-2
                      bg-[#0d5adb]
                      text-white
                      px-4 sm:px-6
                      py-2.5 sm:py-3
                      rounded-full
                      text-sm
                      font-semibold
                      mb-6 sm:mb-8
                    "
                  >
                    ⚡ {slide.badge}
                  </div>

                  {/* Heading */}
                  <h1
                    className="
                      leading-tight
                      text-3xl
                      sm:text-4xl
                      md:text-5xl
                      lg:text-[68px]
                      font-semibold
                      mb-4 sm:mb-6
                    "
                  >
                    <span className="2xl:text-[#0d5adb] sm:text-white md:text-white lg:text-white">
                      {slide.title.split(" ").slice(0, 2).join(" ")}
                    </span>{" "}
                    <span className="2xl:text-[#0d5adb] sm:text-white md:text-white lg:text-white">
                      {slide.title.split(" ").slice(2).join(" ")}
                    </span>
                  </h1>

                  {/* Description */}
                  <p
                    className="
                      lg:text-[#0d5adb]
                      2xl:text-[#0d5adb]
                      sm:text-white
                      lg:text-white
                      text-base
                      sm:text-lg
                      md:text-xl
                      leading-relaxed
                      max-w-2xl
                      mb-10 sm:mb-16
                      font-bold
                    "
                  >
                    {slide.description}
                  </p>

                  {/* Buttons */}
                  <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <button
                    className="
                      bg-[#0d5adb]
                      hover:bg-[#0847b0]
                      text-white
                      px-5 sm:px-6 md:px-8
                      py-2.5 sm:py-3 md:py-3.5
                      rounded-xl md:rounded-2xl
                      text-sm sm:text-base md:text-lg
                      font-semibold
                      transition
                      w-full sm:w-auto
                    "
                  >
                    {slide.cta}
                  </button>

                  <button
                    onClick={() => navigate("/viewmore")}
                    className="
                      bg-white
                      hover:bg-gray-100
                      text-[#0d5adb]
                      px-5 sm:px-6 md:px-8
                      py-2.5 sm:py-3 md:py-3.5
                      rounded-xl md:rounded-2xl
                      text-sm sm:text-base md:text-lg
                      font-semibold
                      transition
                      w-full sm:w-auto
                    "
                  >
                    View Gallery
                  </button>
                </div>
                </motion.div>
              </div>

              {/* Bottom Wave (you can add SVG wave here if needed) */}
{/* Bottom Wave */}
<div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-20 pointer-events-none hidden lg:block">
  {/* Optional wave SVG can go here */}
</div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Hero;